// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerTrademarks":"Footer_footerTrademarks__WvFmD","footerCreated":"Footer_footerCreated__EQt-W","footerName":"Footer_footerName__tvYFq"};